import * as types from "../actions/actionTypes";
import initialState from "./initialState";

export default function personsReducer(state = initialState.persons , action) {
    if (action.type === types.READ_PERSON_SUCCESS)
    {
        return action.persons
    }
    else {
        return state;
    }
}
